import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CorreoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CORREO' htmlFor='input-correo' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='correo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-correo'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CorreoFormGroup)
